var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSweden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagSweden_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagSweden_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagSweden_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagSweden_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagSweden_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2D5A95",
    d: "M-7 44.112h70.487V3H-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3D02F",
    d: "M13.557 44.112h8.228V3h-8.228z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3D02F",
    d: "M-7 27.667h70.487v-8.222H-7z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iNHRidXdnYTM1YSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSJvb2JwNnB5dHJiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iIzR0YnV3Z2EzNWEiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiM0dGJ1d2dhMzVhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjb29icDZweXRyYikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzJENUE5NSIgZD0iTTAgNDEuMTEyTDcwLjQ4NyA0MS4xMTIgNzAuNDg3IDAgMCAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcgMykiLz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjRjNEMDJGIiBkPSJNMjAuNTU3IDQxLjExMkwyOC43ODUgNDEuMTEyIDI4Ljc4NSAwIDIwLjU1NyAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcgMykiLz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjRjNEMDJGIiBkPSJNMCAyNC42NjdMNzAuNDg3IDI0LjY2NyA3MC40ODcgMTYuNDQ1IDAgMTYuNDQ1eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcgMykiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgFlagSweden as ReactComponent };